import { JSX, useState } from "react";
import { Upload } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import ImgCrop from "../../components/ImgCrop/ImgCrop";
import { createImageMaxSizeValidator } from "./imageValidation";

const beforeUploadIcon = createImageMaxSizeValidator(144, 144);

function IconUploadBox({ value, onChange }: { value?: string; onChange?: (v: string) => void }): JSX.Element {
  const [hover, setHover] = useState(false);

  return (
    <ImgCrop aspect={1} showGrid modalTitle="ปรับขนาดไอคอน" modalOk="ยืนยัน" modalCancel="ยกเลิก">
      <Upload
        accept="image/*"
        showUploadList={false}
        beforeUpload={beforeUploadIcon}
        customRequest={({ file, onSuccess }) => {
          onChange?.(URL.createObjectURL(file as File));
          onSuccess?.("ok");
        }}
      >
        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            border: `1px solid ${color.border}`,
            background: value ? `center/cover no-repeat url(${value})` : color.background1,
            position: "relative",
            overflow: "hidden",
            cursor: "pointer",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {!value && <PictureOutlined style={{ color: color.Text3, fontSize: 16 }} />}
          {hover && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(27,40,63,0.72)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 2,
              }}
            >
              <Text fontSize={12} fontWeight={700} color="white" align="center" style={{ lineHeight: "11px" }}>
                เปลี่ยน
              </Text>
            </div>
          )}
        </div>
      </Upload>
    </ImgCrop>
  );
}

export default IconUploadBox;
